module.exports = __webpack_public_path__ + "04_long_black.5b5882a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/04_long_black.png
// module id = EV3z
// module chunks = 0